import CourseInstanceShow from './CourseInstanceShow';
import CourseInstanceList from './CourseInstanceList';
import CourseInstanceCreate from './CourseInstanceCreate';
import CourseInstanceEdit from './CourseInstanceEdit';

export default {
    list: CourseInstanceList,
    create: CourseInstanceCreate,
    edit: CourseInstanceEdit
};
